import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

const workstationOfflineStatus = () => {
  return (
    <div className={style['workstation-offline']}>
      <FormattedMessage defaultMessage='(Offline)' description='printModal.offline' id='sHYATM' />
    </div>
  );
};

const renderNoPrintersAvailable = () => {
  return (
    <DropdownMenuItem className={style['no-printers']} disabled>
      <FormattedMessage defaultMessage='No Printers Available' description='printModal.noPrinters' id='7XVNHL' />
    </DropdownMenuItem>
  );
};

const renderPrinters = (printers, onPrinterSelected) => {
  return printers.map((printer) => (
    <DropdownMenuItem key={printer.id} onClick={() => onPrinterSelected(printer)}>
      <div className={style['printing-selection']}>{printer.name}</div>
    </DropdownMenuItem>
  ));
};

const PrinterDropdownItems = ({ printersGroupedByWorkstation = emptyArray, onPrinterSelected = noop }) => {
  return printersGroupedByWorkstation.map((printerGroup) => [
    <div key={printerGroup.workstationName} className={style['workstation-dropdownitem']} disabled>
      <div>
        {printerGroup.workstationName}
        {!printerGroup.workstationIsOnline && workstationOfflineStatus()}
      </div>
    </div>,
    get(printerGroup, 'printers.length', 0) === 0 ? renderNoPrintersAvailable() : renderPrinters(printerGroup.printers, onPrinterSelected),
  ]);
};

PrinterDropdownItems.propTypes = {
  printersGroupedByWorkstation: PropTypes.array,
  onPrinterSelected: PropTypes.func,
};

export default PrinterDropdownItems;
